import { render, staticRenderFns } from "./CustomOperationsHeader.vue?vue&type=template&id=58a77ea4&scoped=true"
import script from "./CustomOperationsHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomOperationsHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomOperationsHeader.vue?vue&type=style&index=0&id=58a77ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a77ea4",
  null
  
)

export default component.exports